module.exports = __webpack_public_path__ + "static/1-b652e30e86d76749e6ba25753972afc3.jpg";